import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";
// import FusePageSimple from "@fuse/core/FusePageSimple";
// import DemoContent from "@fuse/core/DemoContent";
import {
  Box,
  Button,
  ButtonBase,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// const Root = styled(FusePageSimple)(({ theme }) => ({
//   "& .FusePageSimple-header": {
//     backgroundColor: theme.palette.background.paper,
//     borderBottomWidth: 1,
//     borderStyle: "solid",
//     borderColor: theme.palette.divider,
//   },
//   "& .FusePageSimple-toolbar": {},
//   "& .FusePageSimple-content": {
//     justifyContent: "center",
//     alignItems: "center",
//     //margin:'50%'
//   },
//   "& .FusePageSimple-sidebarHeader": {},
//   "& .FusePageSimple-sidebarContent": {},
// }));

function DegreePursuePage(props) {
  const { t } = useTranslation("examplePage");

  const [bachelor, setBachelor] = useState(false);
  const [bachelorClicked, setBachelorClicked] = useState(false);

  const [masters, setMasters] = useState(false);
  const [mastesClicked, setMastersClicked] = useState(false);

  const [mba, setmba] = useState(false);
  const [mbaClicked, setmbaClicked] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    if (bachelor == true) {
      navigate("/higherlevelbachelor");
    } else if (masters == true) {
      navigate("/highedulevel");
    } else if (mba == true) {
      navigate("/experience");
    }
  };

  const handleClickBachelor = () => {
    if (bachelorClicked == false) {
      setBachelor(true);
      setBachelorClicked(true);

      setMasters(false);
      setMastersClicked(false);
      setmba(false);
      setmbaClicked(false);
    } else {
      setBachelor(false);
      setBachelorClicked(false);

      setMasters(false);
      setMastersClicked(false);
      setmba(false);
      setmbaClicked(false);
    }
  };

  const handleClickMasters = () => {
    if (mastesClicked == false) {
      setMasters(true);
      setMastersClicked(true);

      setBachelor(false);
      setBachelorClicked(false);
      setmba(false);
      setmbaClicked(false);
    } else {
      setMasters(false);
      setMastersClicked(false);

      setBachelor(false);
      setBachelorClicked(false);
      setmba(false);
      setmbaClicked(false);
    }
  };

  const handleClickMBA = () => {
    if (mbaClicked == false) {
      setmba(true);
      setmbaClicked(true);

      setBachelor(false);
      setBachelorClicked(false);
      setMasters(false);
      setMastersClicked(false);
    } else {
      setmba(false);
      setmbaClicked(false);

      setBachelor(false);
      setBachelorClicked(false);
      setMasters(false);
      setMastersClicked(false);
    }
  };
  var cardStyle1 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: bachelor ? "#603aa2" : "#c59bdb60",
    color: "white",
  };
  var cardStyle2 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: masters ? "#603aa2" : "#c59bdb60",
  };
  var cardStyle3 = {
    display: "flex",
    width: "120px",
    transitionDuration: "0.3s",
    height: "120px",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: mba ? "#603aa2" : "#c59bdb60",
  };
  //console.log(bachelor)

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <Typography
                  color="secondary"
                  fontSize={28}
                  align="center"
                  className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry"
                >
                  Which degree do you wish to pursue?
                </Typography>

                <div className="d-flex justify-center mb-20 mt-5 crad">
                  <Card
                    className="mx-20 cardSpacing"
                    onClick={handleClickBachelor}
                    // style={{ backgroundColor: bachelor ? "#603aa2" : "#c59bdb60" }}
                    style={cardStyle1}
                  >
                    <ButtonBase>
                      <CardContent>
                        <div>
                          {/* <FormControlLabel 
      className="flex justify-end"
      control={ <Checkbox  className=" w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>}
      
      /> */}
                          <img
                            className="w-32 sm:w-80 rounded-full "
                            src="/customizedimages/degreecap.png"
                          />
                          <Typography
                            className="font-bold flex justify-center mt-10"
                            style={{
                              color: bachelor ? "#c59bdb" : "#5D3FD3",
                              fontSize: "18px",
                              marginTop: "15%",
                            }}
                          >
                            Bachelors
                          </Typography>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>

                  <Card
                    className="cardSpacing"
                    onClick={handleClickMasters}
                    // style={{ backgroundColor: masters ? "#603aa2" : "#c59bdb60" }}
                    style={cardStyle2}
                  >
                    <ButtonBase>
                      <CardContent>
                        <div>
                          {/* <FormControlLabel 
      className="flex justify-end"
      control={ <Checkbox  className=" w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>}
      
      /> */}
                          <img
                            className="w-32 sm:w-80 rounded-full "
                            src="/customizedimages/degreecap.png"
                          />
                          <Typography
                            className="font-bold flex justify-center  mt-10"
                            style={{
                              color: masters ? "#c59bdb" : "#5D3FD3",
                              fontSize: "18px",
                              marginTop: "15%",
                            }}
                          >
                            Masters
                          </Typography>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>

                  <Card
                    className="mx-20 cardSpacing"
                    onClick={handleClickMBA}
                    // style={{ backgroundColor: mba ? "#603aa2" : "#c59bdb60" }}
                    style={cardStyle3}
                  >
                    {/* <FormControlLabel 
      className="flex justify-end"
      control={ <Checkbox  className=" w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>}
      
      /> */}
                    <ButtonBase>
                      <CardContent>
                        <div>
                          <img
                            className="w-32 sm:w-80 rounded-full "
                            src="/customizedimages/degreecap.png"
                          />
                          <Typography
                            className="font-bold flex justify-center  mt-10"
                            style={{
                              color: mba ? "#c59bdb" : "#5D3FD3",
                              fontSize: "18px",
                              marginTop: "15%",
                            }}
                          >
                            MBA
                          </Typography>
                        </div>
                      </CardContent>
                    </ButtonBase>
                  </Card>
                </div>

                <div className="d-flex mt-5 items-center  justify-center crad">
                  <Button
                    variant="contained"
                    size="large"
                    style={{ backgroundColor: "#603aa2", fontSize: "18px" }}
                    disabled={bachelor || masters || mba ? false : true}
                    onClick={handleClick}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default DegreePursuePage;
